import { z } from 'zod';

import { codeDimensionRule } from './activity-dimensions';

export const CodeCategoryViewModeSchema = z.enum(['PERCENTAGE', 'COUNT', 'NONE']);
export type CodeCategoryViewMode = z.infer<typeof CodeCategoryViewModeSchema>;

export const createCodeBody = z.object({
  code: z.string().min(1),
  description: z.string().min(1),
  tags: z.array(z.string()),
  categoryId: z.uuid(),
  dimensionRule: codeDimensionRule.nullable().optional(),
});
export type CreateCodeBody = z.infer<typeof createCodeBody>;

export const updateCodeBody = z.object({
  code: z.string().min(1),
  description: z.string().min(1),
  tags: z.array(z.string()),
  categoryId: z.uuid().optional(),
  dimensionRule: codeDimensionRule.nullable().optional(),
});
export type UpdateCodeBody = z.infer<typeof updateCodeBody>;

export const codeIncludeQuery = z.object({
  includeMetadata: z.stringbool().default(false),
  includeCategory: z.stringbool().default(false),
});
export type CodeIncludeQuery = z.infer<typeof codeIncludeQuery>;

export const idParam = z.object({ id: z.string().min(1) });
export type IdParam = z.infer<typeof idParam>;

export const createCodeMetadatumBody = z.object({
  prompt: z.string().min(1),
  inputType: z.string().min(1),
  codeId: z.uuid(),
});
export type CreateCodeMetadatumBody = z.infer<typeof createCodeMetadatumBody>;

export const updateCodeMetadatumBody = z.object({
  prompt: z.string().optional(),
  inputType: z.string().optional(),
});
export type UpdateCodeMetadatumBody = z.infer<typeof updateCodeMetadatumBody>;

export const categoryBody = z.object({
  name: z.string().min(1),
  color: z
    .string()
    .regex(/^#([0-9A-Fa-f]{3}){1,2}$/, { message: 'Must be a hex color' }),
  showInReport: z.boolean(),
  showInHeaderAs: CodeCategoryViewModeSchema,
});
export type CategoryBody = z.infer<typeof categoryBody>;
